import { useTranslation } from 'react-i18next'

import { FlagCheckeredIcon, TShirtIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'

import { getColorByPercentage } from '../helpers'
import * as Styles from './styles'

const OverallComplianceProgressBar = ({ percentage, totalProducts, onClick }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.OverAllContainer onClick={onClick}>
        <Styles.ChartTextContainer>
          <FlagCheckeredIcon color={theme.colors.text.subtle} />
          <Text type="allCapsS" color={theme.colors.text.subtle} customStyles={{ textTransform: 'uppercase' }}>
            {t('Puntuación total de cumplimiento')}
          </Text>
        </Styles.ChartTextContainer>
        <Styles.ProgressBarContainer>
          <Styles.ProgressBar>
            <Styles.ProgressBarContent
              animate={{ width: `${percentage}%` }}
              transition={{ duration: 0.8 }}
              gradient={getColorByPercentage(percentage, theme).gradient}
            ></Styles.ProgressBarContent>
          </Styles.ProgressBar>
          <Text type="titleM" color={getColorByPercentage(percentage, theme).normal} customStyles={{ width: '71px' }}>
            <AnimatedNumber target={percentage} format="percent" />
          </Text>
        </Styles.ProgressBarContainer>
      </Styles.OverAllContainer>
      <Styles.TotalItemsContainer>
        <Styles.TotalItemsLabelContainer>
          <TShirtIcon color={theme.colors.text.subtle} />
          <Text type="allCapsS" color={theme.colors.text.subtle} customStyles={{ textTransform: 'uppercase' }}>
            {t('Productos registrados')}
          </Text>
        </Styles.TotalItemsLabelContainer>
        <Text type="titleL">
          <AnimatedNumber target={totalProducts} format="decimal" />
        </Text>
      </Styles.TotalItemsContainer>
    </Styles.Container>
  )
}

export default OverallComplianceProgressBar
